(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.jsHeader = document.querySelector('[js-header]');
      this.menuButton = document.querySelector('[data-menu-drawer-toggle]');
      this.menuDrawer = document.querySelector('.menu-drawer');

      if (this.menuButton) {
        this.menuButton.addEventListener('click', this.handleMenuToggle.bind(this));
      }

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.scrollThreshold = 100;

      this.setHeaderHeight();
      console.log('Initial Header Height:', this.header?.offsetHeight);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      console.log('Scroll listener added');

      this.createObserver();

      document.addEventListener('click', (event) => {
        if (
          this.jsHeader.dataset.menuOpen === 'true' &&
          !this.menuDrawer.contains(event.target) &&
          !this.menuButton.contains(event.target)
        ) {
          this.handleMenuToggle();
        }
      });
    }

    handleMenuToggle() {
      const isOpen = this.jsHeader.dataset.menuOpen === 'true';
      this.jsHeader.dataset.menuOpen = (!isOpen).toString();
      this.menuButton.setAttribute('aria-expanded', (!isOpen).toString());

      if (!isOpen) {
        document.body.style.overflow = 'hidden';
        this.menuDrawer.classList.add('menu-drawer--open');
      } else {
        document.body.style.overflow = '';
        this.menuDrawer.classList.remove('menu-drawer--open');
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      // Only handle transparency on index page
      if (window.location.pathname === '/') {
        if (scrollTop > this.scrollThreshold) {
          this.jsHeader?.classList.remove('header-transparent');
          this.jsHeader?.classList.add('header-inverse');
        } else {
          // Only add transparent back if menu is not open
          if (this.jsHeader?.dataset.menuOpen !== 'true') {
            this.jsHeader?.classList.add('header-transparent');
            this.jsHeader?.classList.remove('header-inverse');
          }
        }
      } else {
        // Ensure header is inverse on all other pages
        this.jsHeader?.classList.remove('header-transparent');
        this.jsHeader?.classList.add('header-inverse');
      }

      // Original scroll behavior
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class BroadcastMenu extends HTMLElement {
    constructor() {
      super();
      this.detailsElement = this.querySelector('details');
      this.summaryElement = this.querySelector('details > summary');
      this.jsHeader = document.querySelector('[js-header]');
      this.bindEvents();
    }

    bindEvents() {
      // Only prevent default on the summary element
      this.summaryElement.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('click', this.handleDocumentClick.bind(this));
    }

    handleClick(event) {
      // Only prevent default if clicking the summary element

      if (event.target === this.summaryElement || event.target.closest('summary') === this.summaryElement) {
        event.preventDefault();
        event.stopPropagation();

        const isOpen = this.detailsElement.hasAttribute('open');

        // Close all other menus first
        this.closeOtherMenus();

        if (!isOpen) {
          // Opening the menu
          this.detailsElement.setAttribute('open', '');
          this.jsHeader?.classList.add('header-inverse');
          this.jsHeader?.classList.remove('header-transparent');
        } else {
          // Closing the menu
          this.detailsElement.removeAttribute('open');
          // Only remove header-inverse if we're on the index page and haven't scrolled past threshold
          if (window.location.pathname === '/' && window.scrollY <= 100) {
            this.jsHeader?.classList.remove('header-inverse');
            this.jsHeader?.classList.add('header-transparent');
          }
        }
      }
    }

    handleDocumentClick(event) {
      // Close menu when clicking outside
      if (!this.contains(event.target)) {
        this.detailsElement.removeAttribute('open');
        // Only remove header-inverse if we're on the index page and haven't scrolled past threshold
        if (window.location.pathname === '/' && window.scrollY <= 100) {
          this.jsHeader?.classList.remove('header-inverse');
          this.jsHeader?.classList.add('header-transparent');
        }
      }
    }

    closeOtherMenus() {
      document.querySelectorAll('gf-broadcast details[open]').forEach((openMenu) => {
        if (openMenu !== this.detailsElement) {
          openMenu.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('gf-broadcast', BroadcastMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-banner"] && !window.DesignMode) return;
  try {
    
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.gf-slideshow__wrapper');
      this.slides = this.querySelectorAll('.gf-slideshow__slide');
      this.prevButton = this.querySelector('.gf-slideshow__control--prev');
      this.nextButton = this.querySelector('.gf-slideshow__control--next');
      this.dots = this.querySelectorAll('.gf-slideshow__dot');

      this.currentSlide = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.slideInterval) || 5000;

      this.init();
    }

    init() {
      this.showSlide(0);
      this.bindEvents();
      if (this.autoplay) 
        this.startAutoplay();
      


    }

    bindEvents() {
      if (this.prevButton) 
        this.prevButton.addEventListener('click', () => this.prevSlide());
      


      if (this.nextButton) 
        this.nextButton.addEventListener('click', () => this.nextSlide());
      


      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.showSlide(index));
      });
    }

    showSlide(index) {
      this.slides[this.currentSlide].classList.remove('is-active');
      this.dots[this.currentSlide].classList.remove('is-active');

      this.currentSlide = index;

      this.slides[this.currentSlide].classList.add('is-active');
      this.dots[this.currentSlide].classList.add('is-active');
    }

    nextSlide() {
      const next = (this.currentSlide + 1) % this.slides.length;
      this.showSlide(next);
    }

    prevSlide() {
      const prev = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.showSlide(prev);
    }

    startAutoplay() {
      this.autoplayInterval = setInterval(() => this.nextSlide(), this.interval);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }
    }
  }

  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.modal__close-button').addEventListener('click', () => {
        this.close();
      });
    }

    open() {
      this.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  customElements.define('gf-slideshow-component', SlideshowComponent);
  customElements.define('modal-dialog', ModalDialog);

// Modal trigger handling
  document.querySelectorAll('.js-modal-trigger').forEach(trigger => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const modalId = trigger.dataset.modalId;
      const modal = document.getElementById(modalId);
      if (modal) 
        modal.open();
      


    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
